import i18n from '~/i18n';

export let i18nMap = keyName => it =>
    filterMap(i18n.t(`cts.${keyName}.${it}`), it);

export let filterMap = (label, value) =>
    value ? { label, value } : { label, value: label };

export default () => [
    {
        ...i18nMap('filterNames')('employment_types'),
        options: ['INTERN', 'FULL_TIME', 'TEMPORARY'].map(
            i18nMap('employmentTypes')
        ),
    },
    {
        ...i18nMap('filterNames')('education_level'),
        options: [
            'BACHELORS_OR_EQUIVALENT',
            'MASTERS_OR_EQUIVALENT',
            'DOCTORAL_OR_EQUIVALENT',
            'MBA_OR_EQUIVALENT',
            'DBA_OR_EQUIVALENT',
        ].map(i18nMap('educationLevels')),
    },
    {
        ...i18nMap('filterNames')('job_category'),
        options: [
            'ACCOUNTING_AND_FINANCE',
            'ADMINISTRATIVE_AND_OFFICE',
            'ADVERTISING_AND_MARKETING',
            'ART_FASHION_AND_DESIGN',
            'BUSINESS_OPERATIONS',
            'COMPUTER_AND_IT',
            'CUSTOMER_SERVICE',
            'EDUCATION',
            'HEALTHCARE',
            'HUMAN_RESOURCES',
            'INSTALLATION_MAINTENANCE_AND_REPAIR',
            'LEGAL',
            'MANAGEMENT',
            'MANUFACTURING_AND_WAREHOUSE',
            'MEDIA_COMMUNICATIONS_AND_WRITING',
            'PROTECTIVE_SERVICES',
            'REAL_ESTATE',
            'SALES_AND_RETAIL',
            'SCIENCE_AND_ENGINEERING',
            'SOCIAL_SERVICES_AND_NON_PROFIT',
            'TRANSPORTATION_AND_LOGISTICS',
        ].map(i18nMap('educationFields')),
    },
    {
        ...i18nMap('filterNames')('address'),
        options: [
            'Argentina',
            'Australia',
            'Austria',
            'Belgium',
            'Brazil',
            'Canada',
            'China',
            'China (Hong Kong SAR)',
            'Croatia',
            'Czechia',
            'Denmark',
            'Finland',
            'France',
            'Germany',
            'Greece',
            'Hungary',
            'India',
            'Indonesia',
            'Ireland',
            'Israel',
            'Italy',
            'Japan',
            'Kenya',
            'Latvia',
            'Lithuania',
            'Luxembourg',
            'Malaysia',
            'Mexico',
            'Myanmar',
            'Netherlands',
            'New Zealand',
            'Norway',
            'Pakistan',
            'Philippines',
            'Poland',
            'Portugal',
            'Romania',
            'Russia',
            'Singapore',
            'Slovakia',
            'South Africa',
            'Spain',
            'Sweden',
            'Switzerland',
            'Taiwan (Province of China)',
            'Thailand',
            'Turkey',
            'USA',
            'Ukraina',
            'United Arab Emirates',
            'United Kingdom',
        ].map(i18nMap('countries')),
        settings: {
            limit: 5,
        },
    },
    {
        ...i18nMap('filterNames')('sector'),
        options: [
            'Consulting',
            'Consumer Goods',
            'Financial Services / Banking',
            'Goverment / Public Administration / Non Profit',
            'International Trade & Development',
            'Manufacturing',
            'Media / Entertainment',
            'Petroleum / Energy',
            'Pharma / Healthcare / Biotech',
            'Real Estate / Construction / Infrastructure',
            'Technology (IT) / Telecom',
            'Transportations & Logistics',
            'Other',
        ].map(i18nMap('sectors')),
    },
];
